const PRODUCTS_ACTIONS_TYPES = {
  SET_PRODUCTS_START: 'SET_PRODUCTS_START',
  SET_PRODUCTS_SUCCESS: 'SET_PRODUCTS_SUCCESS',
  SET_PRODUCTS_FAILURE: 'SET_PRODUCTS_FAILURE',
}

export default PRODUCTS_ACTIONS_TYPES
